import * as React from "react"
import PropTypes from "prop-types"
import {Row, Container, Col} from "react-bootstrap"
import Image from "./elements/image"
import ScrollArrowDown from "./elements/scrollArrowDown"

const HeaderImageArrowDown = ({imageBig, imageSmall, padding={bottom:80, top:80,left:15,right:15}, elementId, readingTime, delay=0, animationDuration=0 }) =>{ 
return (
    <Container id={`${elementId}`} className="component header-image-arrow-down-wrapper" style={{padding:`${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`}}>
        <Row>
            <Col 
                xs={{ span: 12, order:2 }}  
                md={4} 
                className="d-flex flex-column justify-content-between"
                data-sal="slide-up"
                data-sal-delay={delay}
                data-sal-easing="easeOutCirc"
                data-sal-duration={animationDuration}
            >
                {/* {readingTime!==null ? <div className="reading-time">{readingTime} mins</div> : null} */}
                <ScrollArrowDown target={elementId}/>
                <Image imgsrc={imageSmall} />
            </Col>
            <Col 
            xs={{ span: 12, order:1 }} 
            md={{ span: 7, offset: 1, order:2 }}
            data-sal="slide-up"
            data-sal-delay={delay}
            data-sal-easing="easeOutCirc"
            data-sal-duration={animationDuration}
            >
                <Image imgsrc={imageBig} />
            </Col>
        </Row>
    </Container>
)
}
HeaderImageArrowDown.propTypes = {
  imageBig: PropTypes.string,
  imageSmall: PropTypes.string,
  padding: PropTypes.object
}

export default HeaderImageArrowDown